import React from "react";

import HomeIcon from "@mui/icons-material/Home";
import UploadIcon from "@mui/icons-material/Upload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LoginIcon from "@mui/icons-material/Login";
import PersonIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import TransformIcon from "@mui/icons-material/Transform";
import TerminalIcon from "@mui/icons-material/Terminal";
import PasswordIcon from "@mui/icons-material/Password";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import BugReportIcon from "@mui/icons-material/BugReport";
import EmailIcon from "@mui/icons-material/Email";
import { DirectionsCar, TableRows } from "@mui/icons-material";
import LinkIcon from "@mui/icons-material/Link";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import RuleIcon from "@mui/icons-material/Rule";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ScheduleIcon from "@mui/icons-material/Schedule";

export type NavLink = {
	to: string;
	text: string;
	icon?: React.ReactNode;
};

export const USER_LINKS: NavLink[] = [
	{ to: "/home", text: "Home", icon: <HomeIcon /> },
	{ to: "/jobs/dashboard", text: "Jobs", icon: <TableRows /> },
	{ to: "/jobs/submit", text: "Submit Jobs", icon: <UploadIcon /> },
	{ to: "/jobs/ready", text: "Mark Jobs Ready", icon: <CheckCircleIcon /> },
	{ to: "/profile", text: "Profile", icon: <PersonIcon /> },
];

export const LOGIN_LINK: NavLink = { to: "/login", text: "Login", icon: <LoginIcon /> };

export const ADMIN_LINKS: NavLink[] = [
	{ to: "/admin/robots", text: "Robots", icon: <DirectionsCar /> },
	{ to: "/admin/job-diagnostics", text: "Job Diagnostics", icon: <ManageSearchIcon /> },
	{ to: "/admin/mission-report", text: "Mission Report", icon: <AssessmentIcon /> },
	{ to: "/admin/exe-mission-validation", text: "Exe Validation", icon: <RuleIcon /> },
	{ to: "/admin/deal-matcher", text: "Deal Matcher", icon: <LinkIcon /> },
	{ to: "/admin/branch-matcher", text: "Branch Matcher", icon: <AccountTreeIcon /> },
	{ to: "/admin/mission-control-passwords-generator", text: "App Passwords", icon: <PasswordIcon /> },
	{ to: "/admin/password-generator", text: "App Login Generator", icon: <VpnKeyIcon /> },
	{ to: "/admin/mission-control-logs", text: "App Logs", icon: <TerminalIcon /> },
	{ to: "/admin/deal-creator", text: "Deal Creator", icon: <ContentCopyIcon /> },
	{ to: "/admin/import", text: "Import Settings", icon: <SettingsIcon /> },
	{ to: "/admin/geofile-converter", text: "GeoFile Converter", icon: <TransformIcon /> },
];

// export const SOFTWARE_TESTER_LINKS: NavLink[] = [];

export const DEVELOPER_LINKS: NavLink[] = [
	{ to: "/admin/agrian-issues", text: "Agrian", icon: <BugReportIcon /> },
	{ to: "/admin/data-sendback-issues", text: "Data Sendback", icon: <EmailIcon /> },
	{ to: "/admin/scheduling", text: "Scheduling", icon: <ScheduleIcon /> },
];
